<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
   
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30">
      <div class="row">
        <div class="col-12">
          <div class="form-group mb-3">
            <label>Magasins :</label>
            <v-select
              class="custom-select-height"
              v-model="client"
              :options="clientList"
              label="store"
              @update:modelValue="handleAgencySelection"
            >
              <template #option="{ store, nb_colis }">
                <span>{{ store }} - {{ nb_colis }} Colis</span>
              </template>
            </v-select>
          </div>
        </div>
        <div class="col-12">
          <button
            style="float: right;"
            v-if="auth.can('ADD_INV')"
            variant="btn btn-primary"
            @click="addInvoice"
            class="btn btn-primary"
          >
            Ajouter
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import { useAppToast } from "@/composables/useAppToast";
import { useAuthStore } from "@/stores/auth";
import api from "@/utils/axios";
import router from "@/router";

export default defineComponent({
  setup() {
    const { showToast } = useAppToast();
    const auth = useAuthStore();
    const user = auth.user;

    // State for selected client
    const client = ref(null);

    // Dummy client list; replace with your actual data source
    const clientList = ref([]);

    // Handle agency selection
    const handleAgencySelection = (selected: any) => {
      client.value = selected;
    };

    // Add invoice handler
    async function addInvoice() {
      if (!client.value || !client.value.magasin_id) {
        showToast("Merci de remplir tous les champs", "error");
        return;
      }
      const data = new FormData();
      data.append("cstmr", client.value.magasin_id);
      data.append("user_id", user.id);
      data.append("user_name", user.name);

      try {
        const res = await api.post("/api/auth/add_invoice", data);
        if (res.data.message === "success") {
          const routeData = {
            name: "EditInvoicePage",
            params: { id: res.data.Inv.id , refNote: res.data.Inv.invoice_ref },
          };
          window.open(router.resolve(routeData).href, "_blank");
        } else {
          showToast("Une erreur est survenue, veuillez réessayer.", "error");
        }
      } catch (error) {
        showToast("Une erreur est survenue, veuillez réessayer.", "error");
      }
    }

    onMounted(async () => {
      try {
        const response = await api.get(`/api/auth/list_cstmr_invoices`);
        if (response && response.data) {
          clientList.value = response.data;
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    });

    return {
      client,
      clientList,
      handleAgencySelection,
      auth,
      addInvoice,
    };
  },
});
</script>
